"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = notify;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _cnbuilder = require("cnbuilder");
var _reactToastify = require("react-toastify");
var _Notification = _interopRequireDefault(require("./Notification"));
var _NotificationModule = _interopRequireDefault(require("./Notification.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["autoClose", "buttonText", "classNameRoot", "classNameBody", "classNameContent", "icon", "onClick", "testAttrContent", "testAttrDismiss", "type", "title", "message", "showActionButton", "i18nDismissLabel", "variant"];
/**
 * Creates a notification in the global notification queue.
 * @function notify
 * @param {Object} options - The optiosn to pass to the Notification component.
 * @param {String} [options.classNameRoot] - The class to add to the root notification element.
 * @param {String} [options.classNameBody] - The class to add to the body of the notification.
 * @param {String} [options.classNameContent] - The class to add to the content of the notification.
 * @param {String} [options.testAttrContent] - The name of the test attribute to associate to the content.
 * @param {String} [options.testAttrDismiss] - The name of the test attribute to associate to the dismiss button.
 * @param {String('info'|'success'|'critical'|'warning')} [options.type='info'] - Determines the characteristics of the notification.
 * @param {String} options.title - The title of the notification.
 * @param {ReactNode} options.message - The message body of the notification.
 * @param {Boolean} [options.showActionButton=true] - Whether to display the action button.
 * @param {String} [options.i18nDismissLabel='Dismiss notification'] - The aria-label for the dismiss button.
 * @example
 * notify({
 *     type: 'success',
 *     title: 'Download started',
 *     message: 'Your download has started.'
 * });
 * @returns {void}
 */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function notify(options) {
  const {
      autoClose,
      buttonText,
      classNameRoot,
      classNameBody,
      classNameContent,
      icon,
      onClick,
      testAttrContent,
      testAttrDismiss,
      type,
      title,
      message,
      showActionButton,
      i18nDismissLabel,
      variant
    } = options,
    rest = (0, _objectWithoutProperties2.default)(options, _excluded);
  const finalType = type || 'info';
  let closeToast;
  switch (variant) {
    case 'toast':
      closeToast = 10000;
      break;
    case 'inline':
      closeToast = false;
      break;
    case 'bell':
      closeToast = 3000;
      break;
    default:
      closeToast = 10000;
      break;
  }
  let toastId = (0, _reactToastify.toast)();
  const discardAutoDismiss = () => {
    _reactToastify.toast.update(toastId, {
      autoClose: false
    });
  };
  toastId = (0, _reactToastify.toast)( /*#__PURE__*/(0, _jsxRuntime.jsx)(_Notification.default, {
    buttonText: buttonText,
    classNameContent: classNameContent,
    icon: icon,
    onClick: onClick,
    testAttrContent: testAttrContent,
    testAttrDismiss: testAttrDismiss,
    type: finalType,
    title: title,
    message: message,
    showActionButton: showActionButton,
    i18nDismissLabel: i18nDismissLabel,
    variant: variant,
    onFocus: discardAutoDismiss
  }), _objectSpread(_objectSpread({}, rest), {}, {
    autoClose: showActionButton && buttonText ? false : autoClose ? autoClose : closeToast,
    className: (0, _cnbuilder.cnb)({
      [_NotificationModule.default.root]: variant !== 'inline'
    }, {
      [_NotificationModule.default[finalType]]: variant !== 'inline'
    }, {
      [_NotificationModule.default.bell]: variant === 'bell'
    }, classNameRoot),
    bodyClassName: (0, _cnbuilder.cnb)({
      [_NotificationModule.default.body]: variant !== 'inline'
    }, {
      [_NotificationModule.default.withoutMessage]: !message
    }, classNameBody),
    transition: (0, _reactToastify.cssTransition)({
      enter: _NotificationModule.default.enter,
      exit: _NotificationModule.default.exit
    })
  }));
}